import loginBg from "../../../assets/images/loginBg.png";
import { Login } from "../../../components/login/login.component";

export const LoginPage = () => {
  return (
    <div className="site-content">
      <div className="container-fluid">
        <div className="row vh-100">
          <div className="m-auto">
            <div className="container p-0 auth-card">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <img src={loginBg} alt="Login Page" className="login-image" />
                </div>
                <div className="flex-grow-1 d-flex flex-column w-100 p-5 p-xl-4 justify-content-center m-xl-2">
                  <div>
                    <h4 className="justify-content-center d-flex flex-row">
                      Reganalytics <span className="login-header">Auth</span>
                    </h4>
                  </div>
                  <div className="mb-1 text-center">
                    <p className="login-page-text mt-2">
                      Sign In to Start Your Session
                    </p>
                  </div>
                  <Login />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
